import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { captureInstallPrompt, registerServiceWorker } from './pwa';
import './styles/app.css';
import './styles/recipes.css';
import './styles/templates.css';
import './styles/chat.css';
import './styles/knowledge.css';

const root = document.getElementById('root');
if (!root) throw new Error('index.html has no #root element');
captureInstallPrompt();
registerServiceWorker();
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
